import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ReportList from 'admin/common/reports/ReportList.js';
import BriefSummary from 'admin/common/reports/BriefSummary';
import Invoice from 'admin/common/reports/Invoice';
import Location from 'admin/common/reports/Location';
import SKU from 'admin/common/reports/SKU';
import Metal from 'admin/common/reports/Metal';
import Customer from 'admin/common/reports/Customer';
import MetalStone from 'admin/common/reports/MetalStone';
import Size from 'admin/common/reports/Size';
import Stone from 'admin/common/reports/Stone';
import Collection from 'admin/common/reports/Collection';
import Style from 'admin/common/reports/Style';
import SalesPerson from 'admin/common/reports/SalesPerson';
import Item from 'admin/common/reports/Item';
import StockAging from 'admin/common/reports/StockAging';
import PriceRange from 'admin/common/reports/PriceRange';
export default function ReportRoutes() {
    return (
        <Routes>
            <Route exact path='/' element={<ReportList />} > </Route>
            <Route exact path='brief-summary' element={<BriefSummary />} > </Route>
            <Route exact path='invoice-summary' element={<Invoice />} > </Route>
            <Route exact path='customer-summary' element={<Customer />} > </Route>
            <Route exact path='sales-by-location' element={<Location />} > </Route>
            <Route exact path='sales-by-sku' element={<SKU />} > </Route>
            <Route exact path='sales-by-metal' element={<Metal />} > </Route>
            <Route exact path='sales-by-metal-&-stone' element={<MetalStone />} > </Route>
            <Route exact path='sales-by-stone' element={<Stone />} > </Route>
            <Route exact path='sales-by-size' element={<Size />} > </Route>
            <Route exact path='sales-by-collection' element={<Collection />} > </Route>
            <Route exact path='sales-by-style' element={<Style />} > </Route>
            <Route exact path='sales-by-salesperson' element={<SalesPerson />} > </Route>
            <Route exact path='sales-by-item' element={<Item />} > </Route>
            <Route exact path='sales-by-stock-aging' element={<StockAging />} > </Route>
            <Route exact path='item-price-range' element={<PriceRange />} > </Route>
        </Routes>
    )
}
